// extracted by mini-css-extract-plugin
export default {"image":"q4-z","loaded":"r4-z"};